module.exports = __webpack_public_path__ + "img/customer-a-086.f29446d0.png";